import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Card, Button } from "react-bootstrap";
import "../RolEmpleado/ListaDeSaldos/ListaDeSaldos.css";

const ListaMovimientosQR = () => {
  const [saldos, setSaldos] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchSaldos(currentPage);
  }, [currentPage]);

  const fetchSaldos = async (page) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/public/v2/Admin/List/QR`,
        { page: page },
        {
          headers: {
            "Content-Type": "application/json",
            "SERVICIOS-URBANOS-TOKEN": localStorage.getItem("token"),
          },
        }
      );
      if (response.data && response.data.msg) {
        setSaldos(response.data.msg || []);
        setTotalPages(response.data.totalPage || 1);
      } else {
        setError("No se encontraron saldos.");
      }
    } catch (error) {
      //console.error('Error fetching saldos:', error);
      setError("Error al obtener los saldos.");
    } finally {
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = String(date.getUTCFullYear()).slice(-2);
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <div className="lista-saldos-container">
      <Card className="">
        <Card.Body>
          <h2 className="lista-saldos-header">Lista de operaciones QR </h2>

          <Table striped bordered hover className="lista-saldos-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Monto</th>
                <th>Tipo</th>
                <th>Estado</th>
                <th>idBox</th>
                <th>idQR</th>
              </tr>
            </thead>
            <tbody>
              {loading == false &&
                saldos.length > 0 &&
                saldos.map((saldo, index) => (
                  <tr key={saldo._id}>
                    <td>{formatDate(saldo.date)}</td>
                    <td>${saldo.amount }</td>
                    <td>{saldo.typeQR}</td>
                    <td>{saldo.state || "-"}</td>
                    <td>{saldo.idBox || "-"} </td>
                    <td>{saldo.idQr || "-"}</td>
                  </tr>
                ))}
              {loading == false && saldos.length == 0 && (
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Sin movimientos</td>
                  <td></td>
                  <td></td>
                  
                </tr>
              )}
              {loading == true && (
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Cargando...</td>
                  <td></td>
                  <td></td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="lista-saldos-buttons">
            <Button
              variant="secondary"
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              Anterior
            </Button>
            <Button
              variant="secondary"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Siguiente
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ListaMovimientosQR;
